var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("input", {
    staticClass: "form-control form-control-sm",
    class: _vm.inputclass,
    attrs: { type: "number", name: _vm.name, readonly: _vm.readonly },
    domProps: { value: _vm.value },
    on: {
      input: function ($event) {
        _vm.$emit(
          "input",
          $event.target.value ? parseInt($event.target.value) : null
        )
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }